import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { InspectionDetailsTabsComponent } from "./tabs/inspection-details-tabs.component";
import { InspectionDetailsInfoComponent } from "./info/inspection-details-info.component";
import { InspectionDetailsPhotosComponent } from "./photos/inspection-details-photos.component";
import { InspectionDocumentsComponent } from "./documents/inspection-documents.component";
import { InspectionDetailsTimelogComponent } from "./timelog/inspection-details-timelog/inspection-details-timelog.component";
import { TimelogContainerComponent } from "./timelog/timelog-container/timelog-container.component";
import { InspectionDetailsItemsComponent } from "./items/inspection-details-items.component";
import { InspectionDetailsSowComponent } from "./sow/inspection-details-sow.component";
import { NewInspectionGuard } from "src/app/session/guards/new-inspection.guard";
import { HistoryLogComponent } from "./history-log/history-log.component";

const routes: Routes = [
  {
    path: ":id",
    component: InspectionDetailsTabsComponent,
    canActivate: [NewInspectionGuard],
    children: [
      {
        path: "info",
        component: InspectionDetailsInfoComponent,
      },
      {
        path: "items",
        component: InspectionDetailsItemsComponent,
      },
      {
        path: "sow",
        component: InspectionDetailsSowComponent,
      },
      {
        path: "calculations",
        loadChildren: () =>
          import("../../calculations-table/calculations-table.module").then(
            (m) => m.CalculationsTableModule,
          ),
      },
      {
        path: "photos",
        component: InspectionDetailsPhotosComponent,
      },
      {
        path: "inspectors",
        loadChildren: () =>
          import("../../inspectors/inspectors.module").then(
            (m) => m.ItInspectorsModule,
          ),
      },
      {
        path: "documents",
        component: InspectionDocumentsComponent,
      },
      {
        path: "timelog",
        component: TimelogContainerComponent,
      },
      {
        path: "history",
        component: HistoryLogComponent,
      },
      {
        path: "",
        pathMatch: "full",
        redirectTo: "info",
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InspectionDetailsRoutingModule {}
